import { mapMutations, mapState } from 'vuex';

const gaData = {
  steps: {
    step1: '1 - systeemparameters invoeren',
    step2: '2 - motor',
    step3: '3 - type powerpack',
    step4: '4 - systeem uitbreiding'
  },
  interactionTypes: {
    start: 'start',
    click: 'click',
    next: 'next',
    previous: 'previous',
    submitSystem: 'submit_system', // or 'submit_basic_configuration', the supplied GA document is ambiguous. it al
    submitBasicConfiguration: 'submit_basic_configuration',
    overviewSystem: 'overview_system',
    shareSystem: 'share_systeem', //yes, Dutch value English key.
  },
  undefined: 'undefined' //to prevent misspellings
}

export default {
  data() {
    return {
      gaData
    }
  },
  computed: {
    ...mapState('googleAnalytics', ['userHasFirstInteracted'])
  },
  methods: {
    ...mapMutations('googleAnalytics', ['setUserHasFirstInteracted']),
    pushDataLayer(data) {
      if (window.dataLayer === undefined) {
        window.dataLayer = [];
      }

      if( !this.userHasFirstInteracted) {
        this.setUserHasFirstInteracted(true);

        window.dataLayer.push({
          event: 'powerpack_configurator',
          ...data,
          value: gaData.undefined,
          build_id: gaData.undefined,
          interaction_type: gaData.interactionTypes.start,
        });
      }

      window.dataLayer.push({
        event: 'powerpack_configurator',
        ...data
      });
    }
  }
}

